export default "__VITE_ASSET__BExquhgY__"